import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import HourglassFilledSvg from "@ant-design/icons-svg/es/asn/HourglassFilled";
import AntdIcon from "../components/AntdIcon";
var HourglassFilled = function HourglassFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HourglassFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  HourglassFilled.displayName = 'HourglassFilled';
}
export default /*#__PURE__*/React.forwardRef(HourglassFilled);